"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var item_1 = require("common/domain/item");
var React = require("react");
var sortable = require("sortablejs");
var ModalWindowButton_1 = require("./ModalWindowButton");
require("./style/ItemList.css");
var ItemList = /** @class */ (function (_super) {
    __extends(ItemList, _super);
    function ItemList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ClickableItem = function (_a) {
            var done = _a.done, openWindow = _a.openWindow, item = _a.item;
            var Item = _this.props.itemComponent;
            return (React.createElement("div", { onClick: openWindow },
                React.createElement(Item, __assign({ done: done }, item))));
        };
        return _this;
    }
    ItemList.prototype.render = function () {
        var _this = this;
        var _a = this.props, itemComponent = _a.itemComponent, currentItem = _a.currentItem, done = _a.done, fixed = _a.fixed, isSmallWindow = _a.isSmallWindow, items = _a.items, setItems = _a.setItems, sorting = _a.sorting, style = _a.style;
        var Item = itemComponent;
        if (items.length === 0) {
            return React.createElement("div", { className: "ItemList-message", style: style }, "There is no item.");
        }
        return (React.createElement("div", { ref: function (container) { return _this.container = container; }, className: "ItemList-container" + (sorting ? "-shadowed" : ""), style: style }, items.map(function (item) {
            return isSmallWindow ?
                React.createElement(ModalWindowButton_1.default, { key: item.id, buttonComponent: _this.ClickableItem, buttonProps: { done: done, item: item } },
                    React.createElement(Item, __assign({ detailed: true, done: done }, item))) :
                React.createElement(Item, __assign({ key: item.id, done: done, highlighted: currentItem && item_1.equal(item, currentItem) }, item));
        })));
    };
    ItemList.prototype.componentDidMount = function () {
        this.componentDidUpdate();
    };
    ItemList.prototype.componentDidUpdate = function () {
        var _this = this;
        var _a = this.props, done = _a.done, fixed = _a.fixed, setItems = _a.setItems;
        var element = this.container;
        if (!element) {
            return;
        }
        if (!this.sortable) {
            this.sortable = sortable.create(element, {
                animation: 200,
                ghostClass: "ItemList-placeholder",
                onSort: function (_a) {
                    var oldIndex = _a.oldIndex, newIndex = _a.newIndex;
                    var items = __spread(_this.props.items);
                    items.splice(newIndex, 0, items.splice(oldIndex, 1)[0]);
                    setItems(items, done);
                },
                scroll: true,
            });
        }
        this.sortable.option("disabled", fixed);
    };
    return ItemList;
}(React.Component));
exports.default = ItemList;



//////////////////
// WEBPACK FOOTER
// ./src/component/ItemList.tsx
// module id = 615
// module chunks = 0